<template>
  <RecordCom />

</template>

<script>
import RecordCom from "@/components/houqinguanli/RecordCom";
export default {
  components: {
    RecordCom,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped>
</style>